import http from '../../../../../http-common.js';

class UserService {
  getList({ page: page, filter: filter }) {
    const keyword =
      filter?.search === '' || filter?.search === undefined
        ? ''
        : `&keyword=${filter?.search}`;

    return http.get(`/api/v1/backoffice/auth/user/list?page=${page}${keyword}`);
  }

  create(data) {
    return http.post('/api/v1/backoffice/auth/user/create', data);
  }
}

export default new UserService();
